import {SET_NOTIFICATIONS} from "../Actions/Types/notificationActionTypes";

const initialState = {
    notifications: {
        'speciesRequestCount': 0,
    },
};

export const notificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_NOTIFICATIONS:
            return {
                ...state,
                notifications: action.notifications,
            };
        default:
            return state;
    }
};


